module.exports = __webpack_public_path__ + "img/arrows-angle-expand.ba221c6c.svg";